import googleFontJson from './googleWebfonts.json'

export const useGoogleWebfontsList = (): GoogleWebfontsResultsType => {
  return googleFontJson
}

/**
 * @param  {string} fontName 'fira sans' or 'fira+sans' or 'Fira Sans', ignores capitalization and '+'
 * @returns fontName string or null using the correct capitalization
 */
export const useCheckGoogleWebfontsPresence = (fontName: string): string | null => {
  const list = useGoogleWebfontsList()
  const cleanFontName = fontName.replace(/\+/g, ' ').toLocaleLowerCase()
  const googleFont = list.find((list_item) => list_item.family.toLowerCase() === cleanFontName)
  return googleFont?.family || null
}

export type GoogleWebfontsWeights = string[] | null

/**
 * @param  {string} fontName 'fira sans' or 'fira+sans' or 'Fira Sans', ignores capitalization and '+'
 * @returns Array of fontWeight strings as specified by googleFonts or null
 */
export const useGoogleWebfontWeightsLookup = (fontName?: string): GoogleWebfontsWeights => {
  const list = useGoogleWebfontsList()
  if (!fontName) return null

  const cleanFontName = fontName.replace(/\+/g, ' ').toLocaleLowerCase()
  const googleFont = list.find((list_item) => list_item.family.toLowerCase() === cleanFontName)
  const weights = googleFont?.weights
  return weights || null
}

type GoogleWebfontsResultsType = Array<GoogleWebfontsResultObjectType>

type GoogleWebfontsResultObjectType = {
  family: string
  weights?: string[]
}
